import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-note-pop-up',
  templateUrl: './note-pop-up.component.html',
  styleUrls: ['./note-pop-up.component.scss'],
})
export class NotePopUpComponent implements OnInit, OnChanges, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();

  @Input() placeholder: string = '';
  @Input() value: string = '';
  @Input() canEdit = true;
  @Input() updateSuccess: boolean = false;
  @Output() updateSuccessChange = new EventEmitter<boolean>();
  @Output() saveEvent = new EventEmitter();
  @ViewChild('textAreaTrigger', { static: true }) textAreaTrigger: MatMenuTrigger | undefined;
  note = '';
  saved = false;

  public ngOnInit() {
    this.value = this.value || '';
    this.note = this.value;
    this.textAreaTrigger?.menuOpened.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.updateSuccessChange.emit(undefined);
      this.saved = false;
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.value = this.value || '';
      this.note = this.value;
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public save() {
    this.saved = true;
    this.saveEvent.emit(this.note);
    this.textAreaTrigger?.closeMenu();
  }

  public closed() {
    if (this.saved) {
      this.value = this.note;
    } else {
      this.note = this.value;
    }
  }
}
